import React, { Fragment } from 'react';
import _ from 'lodash';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Toggle from 'material-ui/Toggle';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import NumberField from '../../../Base/NumberField';

const types = ['CR', 'DR', 'GN', 'HC', 'BT', 'CL', 'WN', 'PM'];
const typeName = ['Gear', 'Derrick', 'Gantry', 'Hose Crane', 'Boom Transporter', 'Cargo Lift', 'Winch', 'Pump'];

class GearV2 extends React.Component {
    constructor(props) {
        super(props);
        this.addGear = this.addGear.bind(this);
        this.removeGear = this.removeGear.bind(this);
    }

    addGear() {
        const gearV2 = _.cloneDeep(this.props.gearV2);

        gearV2.summary.push({
            type: '',
            quantity: undefined,
            capacity: undefined,
            outreach: undefined,
            radius: undefined,
            maxSWL: undefined,
            combinable: false,
        });

        this.props.changeField([{ field: 'gearV2', value: gearV2 }]);
    }

    removeGear(index) {
        const gearV2 = _.cloneDeep(this.props.gearV2);
        gearV2.summary.splice(index, 1);
        this.props.changeField([{ field: 'gearV2', value: gearV2 }]);
    }

    render() {
        const {
            changeField, getError, gearV2, confirmed, modifiedFields, underStyle, toggleLabelStyle, 
        } = this.props;
        return (
            <Fragment>
                {
                    gearV2.summary.map((gear, index) => (
                        <div key={index} className='row'>
                            <div className={`col-xs-${this.props.fromTc ? '3' : '2'}`}>
                                <SelectField
                                    value={gearV2.summary[index].type || ''}
                                    onChange={(e, i, value) => {
                                        changeField([
                                            {
                                                field: `gearV2[summary][${index}].type`,
                                                value,
                                            },
                                            {
                                                field: 'geared',
                                                value: true,
                                            },
                                        ]);
                                    }}
                                    disabled={confirmed}
                                    errorText={getError && getError(`gearV2[summary][${index}].type`)}
                                    // maxHeight={200}
                                    name='type'
                                    floatingLabelText='Type'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    fullWidth
                                    autoWidth

                                    underlineStyle={modifiedFields && modifiedFields.includes(`gearV2[summary][${index}].type`) ? underStyle : null}
                                >
                                    {
                                        types.map((type, index) => (<MenuItem
                                            key={index}
                                            value={type}
                                            primaryText={typeName[index]}
                                        />))
                                    }
                                </SelectField>
                            </div>
                            <div className='col-xs-1'>
                                <NumberField
                                    name='gearV2[summary].quantity'
                                    floatingLabelText='Quantity'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    value={gearV2.summary[index].quantity || ''}
                                    fullWidth
                                    disabled={!gearV2.summary[index].type}
                                    errorText={getError && getError(`gearV2[summary][${index}].quantity`)}
                                    onChange={(e, value) => {
                                        changeField([{
                                            field: `gearV2[summary][${index}].quantity`,
                                            value,
                                            type: 'number',
                                        }]);
                                    }}
                                    underlineStyle={modifiedFields && modifiedFields.includes(`gearV2[summary][${index}].quantity`) ? underStyle : null}
                                />
                            </div>
                                
                            {
                                this.props.fromTc !== true ?
                                    <React.Fragment>
                                        <div className='col-xs-2'>
                                            <NumberField
                                                name='gearV2[summary].capacity'
                                                floatingLabelText='Capacity, mt'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                value={gearV2.summary[index].capacity || ''}
                                                fullWidth
                                                floatNumber
                                                disabled={!gearV2.summary[index].type}
                                                errorText={getError && getError(`gearV2[summary][${index}].capacity`)}
                                                onChange={(e, value) => {
                                                    changeField([{
                                                        field: `gearV2[summary][${index}].capacity`,
                                                        value,
                                                        type: 'number',
                                                    }]);
                                                }}

                                                underlineStyle={modifiedFields && modifiedFields.includes(`gearV2[summary][${index}].capacity`) ? underStyle : null}

                                            />
                                        </div>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <div className='col-xs-2'>
                                            <NumberField
                                                name='gearV2[summary].capacityMin'
                                                floatingLabelText='Capacity min, mt'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                value={gearV2.summary[index].capacityMin || ''}
                                                fullWidth
                                                type='number'
                                                disabled={!gearV2.summary[index].type}
                                                onChange={(e, value) => {
                                                    changeField([{
                                                        field: `gearV2[summary][${index}].capacityMin`,
                                                        value,
                                                        type: 'number',
                                                    }]);
                                                }}
                                            />
                                        </div>
                                        <div className='col-xs-2'>
                                            <NumberField
                                                name='gearV2[summary].capacityMax'
                                                floatingLabelText='Capacity max, mt'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                value={gearV2.summary[index].capacityMax || ''}
                                                fullWidth
                                                floatNumber
                                                disabled={!gearV2.summary[index].type}
                                                onChange={(e, value) => {
                                                    changeField([{
                                                        field: `gearV2[summary][${index}].capacityMax`,
                                                        value,
                                                        type: 'number',
                                                    }]);
                                                }}
                                            />
                                        </div>
                                    </React.Fragment>
                            }

                                
                            <div className='col-xs-2'>
                                <NumberField
                                    name='outreach'
                                    floatingLabelText='Outreach, m'
                                    floatingLabelStyle={{ fontSize: '13px' }}
                                    value={gearV2.summary[index].outreach || ''}
                                    errorText={getError && getError(`gearV2[summary][${index}].outreach`)}
                                    fullWidth
                                    floatNumber
                                    disabled={!gearV2.summary[index].type}
                                    onChange={(e, value) => {
                                        changeField([{
                                            field: `gearV2[summary][${index}].outreach`,
                                            value,
                                            type: 'number',
                                        }]);
                                    }}

                                    underlineStyle={modifiedFields && modifiedFields.includes(`gearV2[summary][${index}].outreach`) ? underStyle : null}
                                />
                            </div>
                            {
                                this.props.fromTc !== true &&
                                    <React.Fragment>
                                        <div className='col-xs-1'>
                                            <NumberField
                                                name='radius'
                                                floatingLabelText='Radius, m'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                value={gearV2.summary[index].radius || ''}
                                                errorText={getError && getError(`gearV2[summary][${index}].radius`)}
                                                fullWidth
                                                disabled={!gearV2.summary[index].type}
                                                floatNumber
                                                onChange={(e, value) => {
                                                    changeField([{
                                                        field: `gearV2[summary][${index}].radius`,
                                                        value,
                                                        type: 'number',
                                                    }]);
                                                }}
                                                underlineStyle={modifiedFields && modifiedFields.includes(`gearV2[summary][${index}].radius`) ? underStyle : null}
                                            />
                                        </div>
                                        <div className='col-xs-2'>
                                            <NumberField
                                                name='maxSWL'
                                                floatingLabelText='max SWL, mt'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                value={gearV2.summary[index].maxSWL || ''}
                                                errorText={getError && getError(`gearV2[summary][${index}].maxSWL`)}
                                                fullWidth
                                                disabled={!gearV2.summary[index].type}
                                                floatNumber
                                                onChange={(e, value) => {
                                                    changeField([{
                                                        field: `gearV2[summary][${index}].maxSWL`,
                                                        value,
                                                        type: 'number',
                                                    }]);
                                                }}

                                                underlineStyle={modifiedFields && modifiedFields.includes(`gearV2[summary][${index}].maxSWL`) ? underStyle : null}
                                            />
                                        </div>
                                        <div className='col-xs-1 middle-xs center-xs' style={{ display: 'flex' }}>
                                            <div style={{ margin: '25px 0 0 0' }}>
                                                <Toggle
                                                    name='combinable'
                                                    label='Comby'
                                                    disabled={!gearV2.summary[index].type}
                                                    toggled={gearV2.summary[index].combinable}
                                                    onToggle={(e, value) => {
                                                        changeField([{
                                                            field: `gearV2[summary][${index}].combinable`,
                                                            value,
                                                        }]);
                                                    }}

                                                    labelStyle={modifiedFields && modifiedFields.includes(`gearV2[summary][${index}].combinable`) ? toggleLabelStyle : null}
                                                />
                                            </div>
                                        </div>
                                    </React.Fragment>
                            }
                                
                            <div className='col-xs-1 middle-xs center-xs' style={{ display: 'flex' }}>
                                <div style={{ margin: '25px 0 0 0' }}>
                                    {
                                        index === 0 ?
                                            <IconButton
                                                disabled={confirmed}
                                            >
                                                <ContentAddIcon
                                                    onClick={this.addGear}
                                                    color='green'
                                                />
                                            </IconButton>
                                            :
                                            <IconButton
                                                disabled={confirmed}
                                            >
                                                <ContentRemoveIcon
                                                    onClick={() => {
                                                        this.removeGear(index);
                                                    }}
                                                    color='red'
                                                />
                                            </IconButton>
                                    }
                                </div>
                            </div>
                        </div>
                    ))
                }
            </Fragment>);
    }
}

export default GearV2;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/GearV2.jsx